import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'link';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
}
export function Button({
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  children,
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none ring-offset-[#FAF7F2]';
  const variants = {
    primary: 'bg-[#8B7355] text-white hover:bg-[#7A6548] focus-visible:ring-[#8B7355]',
    secondary: 'bg-[#9CAF88] text-white hover:bg-[#8B9E77] focus-visible:ring-[#9CAF88]',
    outline: 'border border-[#8B7355] text-[#8B7355] hover:bg-[#FAF7F2] focus-visible:ring-[#8B7355]',
    ghost: 'hover:bg-[#FAF7F2] text-[#8B7355]',
    link: 'text-[#8B7355] underline-offset-4 hover:underline'
  };
  const sizes = {
    sm: 'h-9 px-3 text-sm',
    md: 'h-10 px-4 py-2',
    lg: 'h-12 px-8 text-lg'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-195">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-196" />}
      {children}
    </button>;
}